
	/**
	 * @description
	 *	Generador de secuencias de intervalos de espera bajo un modelo
	 *	Truncated Exponential Backoff, con el cual es posible regular
	 *	eficientemente un canal de transmisión entre 2 partes.
	 *
	 *	Este regulador satisface la ecuación:
	 *
	 *		time = min(maximumTime, baseTime ^ events)
	 *
	 *	donde 'maximumTime' es el tiempo máximo entre eventos (de ahí que es
	 *	truncado), 'baseTime' es el tiempo de espera inicial para el primer
	 *	evento, 'events' es la cantidad de eventos hasta el momento, y 'time'
	 *	es el tiempo de espera antes del siguiente evento.
	 */

export class TruncatedExponentialBackoff {

	private readonly baseTime: number;
	private readonly maximumTime: number;

	private events: number;

	/**
	 * @description
	 *	Crea una instancia del regulador, opcionalmente con valores por
	 *	defecto pre-calibrados.
	 *
	 * @param baseTime
	 *	Tiempo inicial de espera, por defecto establecido en 1.25 s.
	 * @param maximumTime
	 *	Máximo tiempo de espera, por defecto establecido en 10 s.
	 */
	public constructor(baseTime: number = 1.25, maximumTime: number = 10) {
		this.baseTime = baseTime;
		this.events = 0;
		this.maximumTime = maximumTime;
	}

	public nextInMilliseconds(): number {
		return 1000 * this.nextInSeconds();
	}

	public nextInSeconds(): number {
		++this.events;
		return Math.min(this.maximumTime, this.baseTime ** this.events);
	}
}
